import type { MoneyV2, Product } from "@shopify/hydrogen/storefront-api-types";
import { HeartIcon } from "@components/atoms/Icons/components/HeartIcon";
import { PurchaseMarkup } from "../baseProduct/components/index.client";
import { Link, Money, ProductOptionsProvider } from "@shopify/hydrogen";
import { Separator } from "@components/atoms/separator/index.client";

import { ReactNode, useMemo, useState } from "react";

export interface BaseProductProps {
  product?: Product;
  aboutStockText: ReactNode;
  addToCardButton: boolean;
  onRedirect?: () => void;
}

export function useBaseProductVariant(product: any) {
  const { variants } = product || {};
  const hasVariants = variants?.nodes?.length > 1;

  const [lowestPriceVariant, setLowestPriceVariant] = useState<MoneyV2>();

  const [highestPriceVariant, setHighestPriceVariant] = useState<MoneyV2>();
  const variantId = variants?.nodes[2]?.id?.split("/")[0];

  if (hasVariants) {
    variants.nodes.forEach((variant: any) => {
      const price = Number(variant?.priceV2?.amount);
      if (!isNaN(price)) {
        if (!lowestPriceVariant || price < Number(lowestPriceVariant.amount)) {
          setLowestPriceVariant(variant?.priceV2);
        }

        if (
          !highestPriceVariant ||
          price > Number(highestPriceVariant.amount)
        ) {
          setHighestPriceVariant(variant.priceV2);
        }
      }
    });
  }

  const imgAttributes = useMemo(() => {
    return {
      src: product?.media?.nodes[0].image.url,
      alt: product?.media?.nodes[0].image.altText,
    };
  }, []);

  return {
    models: {
      title: product?.title,
      imgURL: imgAttributes.src,
      variantId,
      lowestPriceVariant,
      highestPriceVariant,
      imgAlt: imgAttributes.alt,
    },
  };
}
export default function BaseProductVariant(
  props: BaseProductProps
): JSX.Element {
  const { aboutStockText, addToCardButton, product, onRedirect } = props;

  const { models } = useBaseProductVariant(product);

  return (
    <ProductOptionsProvider data={product!}>
      <div className="py-4 grid content-start justify-items-center border-solid border border-custom-gray-50 max-w-[335px] w-full lg:w-64 h-[500px]">
        <div className="flex justify-between w-full px-4 items-start">
          {aboutStockText}
          <HeartIcon
            className="mt-0.5 cursor-pointer invisible"
            width="20"
            height="22"
          />{" "}
          {/* TODO: remove invisible tailwind class to show the heart */}
        </div>
        <Link
          onClick={onRedirect}
          className="flex flex-col"
          to={`/products/${product?.handle}?variant=${models.variantId}`}
        >
          <div className="my-2 w-full h-60">
            <img
              className=" object-contain w-full h-full"
              src={models.imgURL}
              alt={models.imgAlt}
              loading="lazy"
            />
          </div>

          <span className="h-[70px] my-1 mx-4 text-center text-clip overflow-hidden font-chivo-regular break-words uppercase tracking-wider">
            {models.title}
          </span>
        </Link>

        <div className="flex gap-2">
          {/* {models.isDiscounted && (
            <Money
              className="my-3 text-gray-200 line-through font-chivo-regular font-medium text-xl tracking-wider"
              data={models.compareAtPrice}
            />
          )} */}
          <Money
            className="my-3 text-custom-dark-blue font-chivo-regular font-medium text-xl tracking-wider"
            data={models.lowestPriceVariant}
          />{" "}
          <span className="my-3 text-custom-dark-blue font-chivo-regular font-medium text-xl tracking-wider">
            {" "}
            -{" "}
          </span>
          <Money
            className="my-3 text-custom-dark-blue font-chivo-regular font-medium text-xl tracking-wider"
            data={models.highestPriceVariant}
          />
        </div>
        {addToCardButton && <PurchaseMarkup />}
      </div>
    </ProductOptionsProvider>
  );
}
